import { EventEmitter, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * GlobalExecutor command
 *
 * @class CommandExecutor
 * @extends EventEmitter
 */
export default class CommandExecutor extends EventEmitter {
    /**
     * This event is triggered before a command will be executed.
     *
     * @event beforeExecute
     * @param {AbstractCommand} command The command that will be executed
     * @param {string} commandName The name of the command
     */

    /**
     * This event is triggered after a command was executed.
     *
     * @event execute
     * @param {AbstractCommand} command The command that was executed
     * @param {string} commandName The name of the command
     */

    /**
     * Execute command by name
     *
     * @param {AbstractCommand} command The command to execute
     * @return {boolean}
     */
    execute(command) {
        this.trigger('beforeExecute', command);
        if (command.isAborted()) return false; // Check if command was aborted via event handler

        command.execute();
        if (command.isAborted()) return false; // Check if command was aborted while executing
        this.trigger('execute', command);

        return true;
    }

    /**
     * Unexecute command by name
     *
     * @param {AbstractCommand} command The command to unexecute
     * @return {boolean}
     */
    unexecute(command) {
        this.trigger('beforeUnexecute', command);
        if (command.isAborted()) return false; // Check if command was aborted via event handler

        command.unexecute();
        if (command.isAborted()) return false; // Check if command was aborted while unexecuting
        this.trigger('unexecute', command);

        return true;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.CommandExecutor = CommandExecutor;
